import React from 'react'
import { useWindowSize } from 'react-use'
import Vector from '../../assets/icons/Vector.svg'
import styles from '../ProjectsContainer/index.module.css'
import { projectData } from './data'

export default function Projects() {
    const { width } = useWindowSize();
    return (
        <div className={styles.projectSection}>
            {projectData.map((p, index) => {
                return (
                    <a
                        style={{ minWidth: width <= 768 && '100%' }}
                        key={index}
                        className={styles._project}
                        href={p.projectLink}
                        target='_blank'
                        rel='noreferrer'
                    >
                        <div className={styles.skillBox}>
                            {p.skills.map((skill, i) => <div key={i} className={styles.skill}>{skill}</div>)}
                        </div>
                        <div className={styles.title}>{p.heading}</div>
                        <div className={styles.desc}>{p.description}</div>
                        <div className={styles.skillVideo}>
                            <iframe title={p.heading} src={p.video}></iframe>
                        </div>
                        <div className={styles.view}>
                            <p className={styles.viewBtn}>View Project</p>
                            <div className={styles.vectorImg}>
                                <img width="100%" height="100%" src={Vector} alt="vector" />
                            </div>
                        </div>
                    </a>
                )
            })}
        </div>
    )
}
